import CrazyCard from './CrazyCard'

export default CrazyCard
